import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import CreateAccountForm from "../../sections/create-account-form";
import VerifyEmailForm from "../../sections/verify-email-form";
import Summary from "../../sections/summary";
import { S_AUTH_TOKEN, S_MEMBERCREATE_CONTRACTID, webStorage } from "../../utils/webStorage";
import useQuery from "../../utils/useQuery";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfoAction } from "../../redux/actions";
import api from "../../utils/api";
import { becomeAMemberSummary, clearComparisonToolApiBody } from "../../redux/actions/becomeAMember";
import { codeTypes } from "../../utils/lynkco-constants";
import HeroGradient from "../../sections/hero-gradient";
import { getEncryptor, isNetworkError } from "../../services/siteService";
import { isBizNull, format } from "../../utils";
import { initialLogic } from "../../services/productService";
import { getSummary } from "../../services/summaryService";
import { bindCreateAccountConsents, getUserInfo } from "../../services/userService";
import { createLeads } from "../../services/leadsService";
import AccordionWrapper from "../../elements/accordion-wrapper";
import { creatingClues } from "../../utils/comparisonTool";
import { selectComparisonToolApiBody, staffInfoSelector, selectBecomeAMemberSummary } from "../../selectors/application";
import { accountAddInfo } from "../../services/caseInfo";
import { getEmailCode } from "../../services/verificationService";
import getSiteInfo from "../../utils/getSiteInfo";
import "./style.scss";

const PreSalesCreateAccount = ({ rendering, fields, lang, page, match }) => {
  const {
    heroHeadingType,
    heroHeadingBody,
    backgroundImage,
    createAccountForm,
    verifyEmailForm,
    backToLogin,
    loginSuccessRedirectUrl,
    defaultRedirect,
    summary,
    termsAndConditionsLevel1DPP,
    termsAndConditionsCheckboxLabelLevel1,
    termsAndConditionsCheckboxBodyLevel1,
    termsAndConditionsLevel2DPP,
    termsAndConditionsCheckboxLabelLevel2,
    termsAndConditionsCheckboxBodyLevel2,
    termsAndConditionsLevel3DPP,
    termsAndConditionsCheckboxLabelLevel3,
    termsAndConditionsCheckboxBodyLevel3
  } = fields;

  const dispatch = useDispatch();
  const setUserInfo = data => dispatch(setUserInfoAction(data));
  const setBecomeAMemberSummary = data => dispatch(becomeAMemberSummary(data));
  const clearComparisonTool = data => dispatch(clearComparisonToolApiBody(data));
  const staffInfo = useSelector(staffInfoSelector);
  const summaryCommons = useSelector(selectBecomeAMemberSummary);
  const comparisonToolApiBody = useSelector(selectComparisonToolApiBody);
  const summaryData = getSummary(summary[0], summaryCommons);
  const {
    newsletter: { id: newsletterConsentNo },
    termsAndConditions,
    createAccountFailedMessage,
    loginNetworkErrorMessage,
    registrationInProcessMessage
  } = createAccountForm[0].fields;
  const [termsAndConditionsContentNo, setTermsAndConditionsConsentNo] = useState(termsAndConditions);
  const [termsAndConditionsProps, setTermsAndConditionsProps] = useState();
  const [createAccountFailed, setCreateAccountFailed] = useState(false);
  const [isNetworkFailed, setIsNetworkFailed] = useState(false);
  const [accountExists, setAccountExists] = useState(false);
  const [phoneExists, setPhoneExists] = useState(false);
  const [registrationInProcess, setRegistrationInProcess] = useState(false);
  const [selectSummary, setSelectSummary] = useState(summaryData);
  const [isInVerificationStep, setIsVerificationStep] = useState(false);
  const [sendCodeFailed, setSendCodeFailed] = useState(false);
  const [reachedMax, setReachedMax] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [submitFailed, setSubmitFailed] = useState(false);
  const [formData, setFormData] = useState(null);
  // const [loginFailed, setLoginFailed] = useState(null);
  const query = useQuery();
  const history = useHistory();
  useEffect(() => {
    let defaultRedirectHref = defaultRedirect?.value.href ? defaultRedirect.value.href : `/${lang}`;
    if (!query.redirect) {
      history.replace(defaultRedirectHref);
    } else {
      //** Measurements */
      let dataLayer = window.dataLayer || [];
      let _currency = "EUR";
      let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
      if (_country === "se") {
        _currency = "SEK";
      }
      let _page = {
        type: page.fields.pageType,
        currency: _currency,
        country: lang
      };
      dataLayer.push({
        event: "virtualPageview",
        virtualPageUrl: history.location.pathname + history.location.search,
        virtualPageTitle: "pre_sales_create_account_" + summaryCommons.membership,
        page: _page
      });
      initialLogic(lang, summaryCommons).then(payload => {
        if (!isBizNull(payload) && summary[0]) {
          selectSummary.images = payload.image;
          // selectSummary.details.deposit.currency = payload.currency;
          selectSummary.details.deposit.deposit.value = payload.formattedPrice;
          let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
          setSelectSummary(selectSummary1);
          // set correct consent according to selected level
          switch (summaryCommons.membershipCode) {
            case "MEMBERSHIP02":
              setTermsAndConditionsProps({
                termsAndConditionsCheckboxLabel: termsAndConditionsCheckboxLabelLevel1,
                termsAndConditionsCheckboxBody: termsAndConditionsCheckboxBodyLevel1
              });
              setTermsAndConditionsConsentNo(termsAndConditionsLevel1DPP);
              break;
            case "MEMBERSHIP03":
              setTermsAndConditionsProps({
                termsAndConditionsCheckboxLabel: termsAndConditionsCheckboxLabelLevel2,
                termsAndConditionsCheckboxBody: termsAndConditionsCheckboxBodyLevel2
              });
              setTermsAndConditionsConsentNo(termsAndConditionsLevel2DPP);
              break;
            case "MEMBERSHIP04":
              setTermsAndConditionsProps({
                termsAndConditionsCheckboxLabel: termsAndConditionsCheckboxLabelLevel3,
                termsAndConditionsCheckboxBody: termsAndConditionsCheckboxBodyLevel3
              });
              setTermsAndConditionsConsentNo(termsAndConditionsLevel3DPP);
              break;
            default:
              console.log(`Did not find ${selectSummary.membershipCode}.`);
          }
        }
      });
    }
  }, [summaryCommons]);
  const bind = async data => {
    return await bindCreateAccountConsents({
      email: data.email,
      countryCode: data.country.code,
      termsAndConditionNos: termsAndConditionsContentNo.map(t => t.id),
      newsletterConsentNo,
      wantsNewsletter: data.subscribed,
      agreedToTerms: data.agreedToTerms
    });
  };

  const onAccountCreate = async (evt, data) => {
    // check if account create is ok, then move to step 2
    // pass sumbitted emial to step 2
    setSubmitting(true);
    setIsNetworkFailed(false);
    setPhoneExists(false);
    setAccountExists(false);
    setRegistrationInProcess(false);
    const encryptor = await getEncryptor(data.email);
    const encryptedPassword = encryptor.encrypt(data.password);
    setFormData(data);
    try {
      await api.account.register.check(null, {
        email: data.email,
        mobileCountryCode: data.mobileCountryCode,
        mobileNo: data.mobileNo,
        password: encryptedPassword
      });
    } catch (ex) {
      switch (ex.code) {
        case "USER_CUSTOMER_0008":
          setAccountExists(true);
          break;
        case "USER_CUSTOMER_026":
          setPhoneExists(true);
          break;
        case "USER_CUSTOMER_0031":
          setRegistrationInProcess(true);
          break;
        default:
          setCreateAccountFailed(true);
          break;
      }
      setSubmitting(false);
      return;
    }
    try {
      await getEmailCode(data.email, codeTypes.activeAccount);
      setIsVerificationStep(true);
    } catch (ex) {
      if (ex.code === "USER_CUSTOMER_0013") {
        setReachedMax(true);
      } else {
        setSendCodeFailed(true);
      }
    }
    setSubmitting(false);
  };
  // const onResendVerificationCode = () => {};

  const onVerificationCodeSubmitted = async (evt, data) => {
    let contractId;
    try {
      contractId = await bind(formData);
      const siteInfo = await getSiteInfo();
      const encryptor = await getEncryptor(formData.email);
      const encryptedPassword = encryptor.encrypt(formData.password);
      const body = {
        verify: {
          email: formData.email,
          verificationCode: data.code,
          type: codeTypes.activeAccount
        },
        account: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          countryId: formData.country.code,
          birthday: formData.birthday,
          password: encryptedPassword,
          mobileCountryCode: formData.mobileCountryCode,
          mobileNo: formData.mobileNo,
          contractId: contractId,
          subscribed: formData.subscribed ? "1" : "0",
          dateFormat: siteInfo.dateFormat,
          email: formData.email
        }
      };
      if (staffInfo?.account?.userName) {
        body.account.staff = staffInfo?.account?.userName;
      }
      await api.account.register.byEmail(null, body);
    } catch (ex) {
      console.log("ex", ex);
      if (isNetworkError(ex)) {
        setIsNetworkFailed(true);
      } else {
        switch (ex.code) {
          case "USER_CUSTOMER_0008":
            setAccountExists(true);
            setIsVerificationStep(false);
            break;
          case "USER_CUSTOMER_0011":
            setSubmitFailed(true);
            break;
          case "USER_CUSTOMER_026":
            setPhoneExists(true);
            setIsVerificationStep(false);
            break;
          case "USER_CUSTOMER_0031":
            setRegistrationInProcess(true);
            break;
          default:
            setCreateAccountFailed(true);
            break;
        }
      }
      return;
    }
    await login();
    webStorage.set(S_MEMBERCREATE_CONTRACTID, contractId);
    if (formData.subscribed && contractId) {
      await createLeads(lang, formData.email, formData.country.code, contractId);
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    //** Measurements */
    let dataLayer = window.dataLayer || [];
    let membershipLevel = "";

    switch (summaryCommons.membershipCode) {
      case "MEMBERSHIP01":
        membershipLevel = "Level0";
        break;
      case "MEMBERSHIP02":
        membershipLevel = "Level1";
        break;
      case "MEMBERSHIP03":
        membershipLevel = "Level2";
        break;
      case "MEMBERSHIP04":
        membershipLevel = "Level3";
        break;
    }
    dataLayer.push({
      event: "accountVerify",
      eventCategory: "account",
      eventAction: "verify",
      eventLabel: membershipLevel
    });
  };

  const login = async () => {
    // setLoginFailed(false);
    // const {
    //   fields: { loginSuccessRedirectUrl }
    // } = createAccountForm;
    // const siteInfo = getSiteInfo(lang);
    // const headers = {
    //   ...siteInfo,
    //   lang: lang
    // };
    const encryptor = await getEncryptor(formData.email);
    try {
      const { obj: token } = await api.auth.token(null, {
        username: formData.email,
        password: encryptor.encrypt(formData.password)
      });
      webStorage.set(S_AUTH_TOKEN, {
        ...token,
        loginTime: new Date().getTime()
      });
      const newUser = await getUserInfo();
      setUserInfo(newUser);
      creatingClues(newUser, summaryCommons?.membershipCode, comparisonToolApiBody).then(res => {
        if (!isBizNull(res)) {
          clearComparisonTool();
        }
      });
      accountAddInfo({
        customerNumber: newUser?.customerNumber,
        color: summaryCommons?.color?.preSelectValue?.defaultLanguageValue,
        engine: summaryCommons?.engine?.preSelectValue?.defaultLanguageValue
      });
      if (query.redirect) {
        if (query.redirect.startsWith("https://") || query.redirect.startsWith("http://")) {
          global.location.href = `${query.redirect}?token=${token.accessToken}`;
        } else {
          history.replace(query.redirect);
        }
      } else if (loginSuccessRedirectUrl.value) {
        global.location.href = loginSuccessRedirectUrl.value.href;
      }
    } catch (ex) {
      if (isNetworkError(ex)) {
        setIsNetworkFailed(true);
      } else {
        setIsNetworkFailed(false);
        // setLoginFailed(true);
      }
    }
  };
  let backToLoginValue = JSON.parse(JSON.stringify(backToLogin));
  if (backToLoginValue && backToLoginValue.value && backToLoginValue.value.href && query.redirect && !(query.redirect.startsWith("https://") || query.redirect.startsWith("http://"))) {
    backToLoginValue.value.href += `?redirect=${encodeURIComponent(query.redirect)}`;
  }
  const summaryProps = {
    ...selectSummary,
    match: match,
    callback: ({ color, engine }) => {
      let becomeAMemberSummary = {
        ...summaryCommons,
        engine: {
          ...summaryCommons.engine,
          preSelectValue: engine
        },
        color: {
          ...summaryCommons.color,
          preSelectValue: color
        }
      };
      setBecomeAMemberSummary(becomeAMemberSummary);
    }
  };
  const createAccountFormProps = {
    lang,
    ...createAccountForm[0].fields,
    ...termsAndConditionsProps,
    createAccountFailed,
    isNetworkFailed,
    accountExists,
    phoneExists,
    registrationInProcess,
    backToLogin: backToLoginValue,
    submitting,
    preFilledData: formData,
    submitCreateAccount: (evt, data) => onAccountCreate(evt, data)
  };
  const verifyEmailFormProps = {
    ...verifyEmailForm[0].fields,
    sendCodeFailed,
    isReachedMax: reachedMax,
    submitFailed,
    submittedEmail: formData?.email,
    codeType: codeTypes.activeAccount,
    lang,
    onVerificationCodeSubmitted,
    createAccountFailed,
    isNetworkFailed,
    registrationInProcess,
    createAccountFailedMessage,
    loginNetworkErrorMessage,
    registrationInProcessMessage
  };
  return (
    <div className="pre-sales-create-account grid" datasourceid={rendering.dataSource}>
      <HeroGradient
        {...{
          heading: heroHeadingBody,
          headingType: heroHeadingType,
          backgroundImage
        }}
      />

      {summary[0] && (
        <div className="summary-container-mobile">
          <AccordionWrapper
            heading={{
              ...summaryProps.text.heading,
              typographyClass: "tpye-link"
            }}
          >
            <Summary
              {...{
                ...summaryProps,
                text: { ...summaryProps.text, heading: null },
                match: match
              }}
            />
          </AccordionWrapper>
        </div>
      )}

      <section className="create-account-form-container">
        {!isInVerificationStep && <CreateAccountForm {...createAccountFormProps} />}
        {isInVerificationStep && <VerifyEmailForm {...verifyEmailFormProps} />}
      </section>
      {summary[0] && (
        <section className="summary-container">
          <Summary {...summaryProps} />
        </section>
      )}
    </div>
  );
};

PreSalesCreateAccount.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    heroHeadingType: PropTypes.object,
    heroHeadingBody: PropTypes.object,
    summary: PropTypes.array,
    createAccountForm: PropTypes.array
  })
};
export default PreSalesCreateAccount;
